import { lingoChatABTestRouteConfig } from '@/config/abTestConfig'
import {
  getRouteConfigForVariant,
  navigateToNextOnboardingPage,
} from '@app-studio-web/ui/helpers/abTestRouting'
import { trackOnboardingFormData } from '@app-studio-web/ui/helpers/snowplowTracking'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const variant = getABTestVariantFromContext()
  const formData = await request.formData()

  trackOnboardingFormData({
    formData,
    url: request.url,
    orderedRoutes: getRouteConfigForVariant(
      variant,
      lingoChatABTestRouteConfig,
    ),
  })

  return navigateToNextOnboardingPage({
    request,
    routeConfig: lingoChatABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
